module.exports = __webpack_public_path__ + "static/media/icon-checkbox-blue.4a5932b3.svg";